import React from 'react'
import ContentLoader, { Rect } from 'react-content-loader/native'
import styled from 'styled-components'
import { white, newPurple } from '@qirapagos/lib/theme/colors'

const SkeletonContainer = styled.div`
  width: 100%;
  max-width: 1044px;
  margin: 0 auto;
  padding: 24px 0 48px;
`

const InvestmentOrderSkeleton = () => (
  <SkeletonContainer>
    <ContentLoader
      speed={2.5}
      interval={0}
      width="100%"
      height="60vh"
      viewBox="0 0 100 60"
      backgroundColor={newPurple}
      foregroundColor={white}
    >
      <Rect x="0" y="0" rx="0.6" ry="0.6" width="100" height="100%" />
    </ContentLoader>
  </SkeletonContainer>
)

export default InvestmentOrderSkeleton
